<div class="indication-option">
    <ng-container *ngFor="let indication of availableIndications">
        <div class="radio-wrapper">
            <app-radio-button
                    [checked]="selectedEducationId === indication.id"
                    [label]="indication.title"
                    [value]="indication.id"
                    [ariaLabel]="'QUESTIONNAIRE.FIRST_INJECTION' | translate"
                    (radioButtonChanged)="onClickRadioButtons($event)">
            </app-radio-button>
        </div>
    </ng-container>
</div>
<div class="use-case-option">
    <div class="select-wrapper">
        <app-select-menu
                [labelWidth]="'1fr'"
                [dropdownWidth]="'240px'"
                [dropdownHeight]="40"
                [labelText]="'ONBOARDING.CONSENT_USE_CASE.TITLE' | translate"
                [ariaLabel]="'ONBOARDING.CONSENT_USE_CASE.TITLE' | translate"
                [options]="useCaseOptions"
                [disabled]="basicIndicationSelected"
                [selectedId]="selectedUseCase"
                (valueChangeEvent)="onSelectUseCaseChange($event)">
        </app-select-menu>
    </div>
    <div class="checkbox-wrapper">
        <app-checkbox
                [cssClass]="'small'"
                [disabled]="isCheckBoxDisabled()"
                [checked]="allowCustomUseCase"
                [disableRipple]="true"
                [label]="'USER_MANAGEMENT.ALLOW_CUSTOM_USE_CASE' | translate"
                [labelPosition]="'after'"
                (changeEvent)="onAllowCustomUseCase()">
        </app-checkbox>
    </div>
</div>
